<template>
  <div class="goods-image">
    <div class="largeImage" v-if="images && images.length">
      <template v-if="images && images[currPicIndex]">
        <img lazy-load fit="scale-down" v-if="!images[currPicIndex].isVideo"
          :src="images[currPicIndex].isVideo ? images[currPicIndex].thumbnails : images[currPicIndex].url" @click="clickImage(images,i)" />
      </template>
      <div id="J_prismPlayer" v-else></div>
    </div>
    <div class="largeImage" v-else>
       <img lazy-load fit="scale-down" 
          :src="logo" />
    </div>
    <div class="image-listbox">
      <template v-if="images && images.length>5">
        <div class="box" @click="clickImage(images,currPicIndex-1)" :style="{background:`url(${ showImages[0] && images[showImages[0].index -1] && (images[showImages[0].index-1].isVideo 
        ? images[showImages[0].index-1].thumbnails : images[showImages[0].index-1].url)})
                   no-repeat center /80px 80px`,position: 'relative'}">
          <div class="box-pre" />
        </div>
        <template v-for="img in showImages">
          <div :class="`box ${img.index == currPicIndex ? 'box-hover' : ''}`" :key="img.index">
            <img lazy-load fit="scale-down" :src="img.isVideo ?img.thumbnails : img.url" @click="clickImage(images,img.index)" />
          </div>
        </template>
        <div class="box" @click="clickImage(images,currPicIndex+1)" :style="{background:`url(${ showImages[2] && images[showImages[2].index+1] && (images[showImages[2].index+1].isVideo ? images[showImages[2].index+1].thumbnails : images[showImages[2].index+1].url)})
                   no-repeat center /80px 80px`,position: 'relative'}">
          <div class="box-next" />
        </div>
      </template>
      <template v-else-if="images && images.length<=5">
        <div :class="`box ${i == currPicIndex ? 'box-hover' : ''}`" v-for="(img,i) in images" :key="i">
          <img lazy-load fit="scale-down" :src="img.isVideo ?img.thumbnails : img.url" @click="clickImage(images,i)" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ImageViews',
    props: {
      images: {
        type: Array,
        default () {
          return [{
            index: 0,
            url: '',
            thumbnails: '',
            isVideo: false,
          }];
        }
      },
      logo: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        showImages: [],
        currPicIndex: 0,
      }
    },
    methods: {
      init() {
        //当前可以显示的图片
        if (this.images && this.images.length > 0)
        {
          this.currPicIndex = 0
          if (this.images.length > 5) {
            this.images.map((v, i) => {
              if (i < 3) {
                v.index = i
                return this.showImages.push(v)
              }
            })
          }
        }
      },
      //切换图片
      clickImage(data, i) {
        if (i < 0 || i == data.length) {
          // console.log(i)
          return
        }
        if (!this.showImages.includes(data[i])) {
          data[i].index = i
          if (i < this.currPicIndex) {
            this.showImages.unshift(data[i])
            this.showImages.pop()
          } else {
            this.showImages.push(data[i])
            this.showImages.shift()
          }
        }
        this.currPicIndex = i
      },
    }
  }
</script>

<style lang="less">
  .goods-image {

    .largeImage {
      max-width: 440px;
      min-width: 440px;
      max-height: 440px;
      min-height: 440px;
      line-height: 440px;

      img {
        max-width: 440px;
        max-height: 440px;
        display: inline-block;
        vertical-align: middle;
      }
    }

    .image-listbox {
      display: flex;
      flex-direction: row;
      margin-top: 20px;

      .box {
        width: 80px;
        height: 80px;
        box-shadow: 0 0 0 1px rgba(232, 232, 232, 1);
        margin-right: 10px;
        line-height: 76px;

        img {
          max-width: 80px;
          max-height: 80px;
          display: inline-block;
          vertical-align: middle;
        }

        &:last-child {
          margin-right: 0;
        }


        .box-pre,
        .box-next {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
        }

        .box-pre {
          background: rgba(255, 255, 255, 0.8) url('../assets/goods/pre.png') no-repeat center /30px 30px;

          &:hover {
            background: rgba(255, 255, 255, 0.8) url('../assets/goods/pre-hover.png') no-repeat center /30px 30px;
            box-shadow: 0 0 0 2px rgba(15, 110, 233, 1);
          }
        }

        .box-next {
          background: rgba(255, 255, 255, 0.8) url('../assets/goods/next.png') no-repeat center /30px 30px;

          &:hover {
            background: rgba(255, 255, 255, 0.8) url('../assets/goods/next-hover.png') no-repeat center /30px 30px;
            box-shadow: 0 0 0 2px rgba(15, 110, 233, 1);
          }
        }
      }

      .box-hover {
        box-shadow: 0 0 0 2px rgba(15, 110, 233, 1);
      }
    }
  }
</style>